import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as serviceWorker from "./serviceWorker";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { routerMiddleware } from "react-router-redux";

import { createStore, applyMiddleware, combineReducers } from "redux";
import menureducer from "./Reducers/menureducer";
import outletreducer from "./Reducers/outletreducer";
import orderRecordreducer from "./Reducers/OrderRecordsreducer";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import history from "./utils/history.js";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const persistConfig = {
  key: "root",
  storage
};

const rootReducer = combineReducers({
  menuR: menureducer,
  outletR: outletreducer,
  recordR: orderRecordreducer
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const storeContainer = history => {
  const routerMware = routerMiddleware(history);
  let store = createStore(
    persistedReducer,
    applyMiddleware(thunk, routerMware)
  );
  let persistor = persistStore(store);
  return { store, persistor };
};

let storeC = storeContainer(history);
const app = (
  <Provider store={storeC.store}>
    <PersistGate loading={null} persistor={storeC.persistor}>
      <Router history={history}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <App />
        </MuiPickersUtilsProvider>
      </Router>
    </PersistGate>
  </Provider>
);
ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
